import AppService from '@/services/AppService.js'
const namespaced = true
const state = {
    lists: [],
    list: {},
    message: '',
    type: '',
    code: '',
    base_currency: '',
    exchange_status: '',
    export: [],
    currency_code: '',
    current_rate_id: '',
    exchange_rate_value: ''
}
const mutations = {
    SET_EXCHANGE_RATE(state, data) {
        state.exchange_rate_value = data
    },
    EXCHANGE_RATE_IMPORT_LIST(state, list) {
        state.list = list;
        state.error = "";
    },
    SET_DATAS(state, lists) {
        state.lists = lists.list
        state.base_currency = lists.base_currency
        state.exchange_status = lists.exchange_status
    },
    STATUS_DETAILS(state, data) {
        state.message = data.data.status;
        state.type = data.data.type;
    },
    STATUS_CODE(state, code) {
        state.code = code
    },
    CURRENCY_DETAILS(state, data) {
        state.list = data.list
    },
    EXACHANGE_RATE(state, data) {
        state.exchange_status = data.exchange_status
    },
    EXPORT_DATAS(state, lists) {
        state.export = lists
    },
    SET_EXCHANGE_RATE_DATAS(state, data) {
        state.lists = data.list
        state.exchange_status = data.exchange_status
        state.currency_code = data.currency_code
        state.current_rate_id = data.current_rate_id
    },
    MESSAGE_RESULT(state, message) {
        state.message = message
    },
}
const actions = {
    fetchLists({
        commit,
        rootState
    }) {

        return AppService.currency.getCurrencyList(rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('SET_DATAS', response.data) // getting all the list in the api call
                    rootState.customer.currency_list = response.data.list
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    createCurrency({
        commit,
        rootState
    }, data) {

        return AppService.currency.createCurrency(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {

                    commit("STATUS_DETAILS", response);
                    commit('STATUS_CODE', response.status)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    updateCurrency({
        commit,
        rootState
    }, {
        id,
        data
    }) {
        return AppService.currency.updateCurrency(id, data, rootState.session.token)
            .then(response => {
                commit("STATUS_DETAILS", response);
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchCurrencyDetails({
            commit,
            rootState
        },
        id
    ) {
        return AppService.currency.getCurrencyDetails(id, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                commit('CURRENCY_DETAILS', response.data)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    exchangeRateStatus({
            commit,
            rootState
        },
        data
    ) {
        return AppService.currency.exchangeRateStatusChange(data, rootState.session.token)
            .then(response => {
                commit("STATUS_DETAILS", response);
                commit("EXACHANGE_RATE", response.data);
                rootState.permission.org_details.exchange_rate_status = response.data.exchange_status
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchexportLists({
        commit,
        rootState
    }) {
        return AppService.currency.getExRateExport(rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    deletecurrency({
            commit,
            rootState
        },
        data
    ) {
        return AppService.currency.deletecurrency(data, rootState.session.token)
            .then(response => {
                commit("STATUS_DETAILS", response);
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    deleteExchangeRate({
            commit,
            rootState
        },
        data
    ) {
        return AppService.currency.deleteExchangeRate(data, rootState.session.token)
            .then(response => {
                commit("STATUS_DETAILS", response);
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchExRateLists({
        commit,
        rootState
    }, data) {
        return AppService.currency.getExRateList(data.id, data.sort, data.label, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.status != 200) {
                    commit("STATUS_DETAILS", response);
                    commit('STATUS_CODE', response.status)
                } else {
                    commit('STATUS_CODE', response.status)
                    commit('SET_EXCHANGE_RATE_DATAS', response.data) // getting all the list in the api call
                    // rootState.permission.reporting_tags = response.data.data.reporting_tag_list
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    addExchangeRate({
        commit,
        rootState
    }, data) {

        return AppService.currency.addExchangeRate(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('STATUS_DETAILS', response) // getting all the list in the api call
                    // rootState.permission.reporting_tags = response.data.data.reporting_tag_list
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    importexchangeratevalidation({
        commit,
        rootState
    }, data) {

        return AppService.currency.importExchangeRateValidation(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EXCHANGE_RATE_IMPORT_LIST', response.data); // getting all the list in the api call
                    return response.data
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    importExchangeRate({
        commit,
        rootState
    }, data) {

        return AppService.currency.importExchangeRate(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('MESSAGE_RESULT', response.data.status); // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchExchangeRate({
            commit,
            rootState
        },
        data
    ) {
        return AppService.currency.getExchangeRate(data, rootState.session.token)
            .then(response => {
                commit("SET_EXCHANGE_RATE", response.data);
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },


}
export default {
    namespaced,
    state,
    mutations,
    actions
}